var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import { hideMenuProvider } from '../../utilities/picker.tools';
import stylesGlobal from '../shared/sds-datepicker-item/_sds-date-picker-base.lit.scss';
import '../shared/sds-datepicker-item/sds-datepicker-item.lit';
import '../shared/calendar/sds-calendar.lit';
import { displayMonthDate, monthDateToKey, monthKeyToDate, } from './month-picker-calculations';
import { parseAndValidateDate } from '../date/date-picker-calculations';
import styles from '../sds-date-picker.lit.scss';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-month-picker` is a web component that allows users to select a specific month and year.
 * It provides an intuitive interface for navigating through months, making it ideal for scenarios
 * where selecting a month is required, such as setting deadlines, scheduling events, or filtering data by month.
 *
 * ### Features:
 * - **Month and Year Selection**: Users can easily navigate and select a month and year from the dropdown.
 * - **Locale Support**: The component formats month names and year ranges according to regional settings.
 * - **Events**: Emits events to notify parent components of changes in selection.
 */
let SdsMonthPicker = (() => {
    var _SdsMonthPicker_placeholder_accessor_storage, _SdsMonthPicker_selectedMonth_accessor_storage, _SdsMonthPicker__internalValue_accessor_storage, _SdsMonthPicker_currentMonth_accessor_storage, _SdsMonthPicker_hint_accessor_storage, _SdsMonthPicker_disabled_accessor_storage, _SdsMonthPicker_invalid_accessor_storage, _SdsMonthPicker_errorMessage_accessor_storage, _SdsMonthPicker__locale_accessor_storage, _SdsMonthPicker__contextMenu_accessor_storage, _SdsMonthPicker__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-month-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _selectedMonth_decorators;
    let _selectedMonth_initializers = [];
    let _selectedMonth_extraInitializers = [];
    let __internalValue_decorators;
    let __internalValue_initializers = [];
    let __internalValue_extraInitializers = [];
    let _currentMonth_decorators;
    let _currentMonth_initializers = [];
    let _currentMonth_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __locale_decorators;
    let __locale_initializers = [];
    let __locale_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsMonthPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsMonthPicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.month_picker.placeholder'));
            _SdsMonthPicker_selectedMonth_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _selectedMonth_initializers, void 0)));
            _SdsMonthPicker__internalValue_accessor_storage.set(this, (__runInitializers(this, _selectedMonth_extraInitializers), __runInitializers(this, __internalValue_initializers, void 0)));
            _SdsMonthPicker_currentMonth_accessor_storage.set(this, (__runInitializers(this, __internalValue_extraInitializers), __runInitializers(this, _currentMonth_initializers, void 0)));
            _SdsMonthPicker_hint_accessor_storage.set(this, (__runInitializers(this, _currentMonth_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsMonthPicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsMonthPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsMonthPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsMonthPicker__locale_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __locale_initializers, 'en')));
            _SdsMonthPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, __locale_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsMonthPicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsInnerMonthPicker = __runInitializers(this, __inputDate_extraInitializers);
            this.stylesGlobal = stylesGlobal;
            this.hideMenu = hideMenuProvider(this);
            this.handleCleared = () => {
                this._internalValue = undefined;
                this.updateSelectedMonth();
                this.hideContextMenu();
                // Keep focus on the input after clearing
                this._inputDate.focused = true;
                // Set currentMonth to current date so calendar opens on current month
                const now = new Date();
                this.currentMonth = `${now.getFullYear()}/${now.getMonth() + 1}`;
            };
            this.handleInputClick = (event) => {
                // Check if the click originated from a button by looking at the event path
                const path = event.composedPath();
                const hasButton = path.some(element => element instanceof HTMLElement && element.tagName === 'BUTTON');
                if (hasButton) {
                    return; // Don't open menu if click came from a button
                }
                this.showContextMenu();
            };
            this.handleMonthPicked = (event) => {
                this.updateSelectedMonth([event.detail.year, event.detail.month]);
            };
            this.handleYearChanged = (event) => {
                var _a;
                (_a = this._sdsInnerMonthPicker) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(keyYear => event.detail.year === keyYear ? 'selected' : 'none');
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
            this.handleKeyDown = (event) => {
                var _a, _b;
                if (this.disabled)
                    return;
                const originalTarget = event.composedPath()[0];
                if (originalTarget && originalTarget.closest('button')) {
                    return;
                }
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                        this.hideContextMenu();
                    }
                    else {
                        this.showContextMenu();
                    }
                }
                else if (event.key === 'Escape') {
                    event.preventDefault();
                    if ((_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.opened) {
                        this.hideContextMenu();
                    }
                }
            };
        }
        /**
         * Sets the placeholder text for the month picker input, providing a hint to users when no month is selected.
         * This helps guide users to understand the expected input or purpose of the month selection.
         *
         * This attribute is useful for improving accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the month picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsMonthPicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsMonthPicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Represents the currently selected month within the month picker.
         *
         * The value can be either a `LocalMonth` object or `undefined` if no month is selected.
         *
         * When this attribute is set, it will automatically update the UI to reflect the selected month.
         *
         * @attr {LocalMonth} selected-month - The currently selected month in the month picker.
         */
        get selectedMonth() { return __classPrivateFieldGet(this, _SdsMonthPicker_selectedMonth_accessor_storage, "f"); }
        set selectedMonth(value) { __classPrivateFieldSet(this, _SdsMonthPicker_selectedMonth_accessor_storage, value, "f"); }
        /** Internal storage for the selected month as LocalMonth array */
        get _internalValue() { return __classPrivateFieldGet(this, _SdsMonthPicker__internalValue_accessor_storage, "f"); }
        set _internalValue(value) { __classPrivateFieldSet(this, _SdsMonthPicker__internalValue_accessor_storage, value, "f"); }
        /**
         * The selected month value. Supports multiple input formats:
         * - String format (YYYY/MM) - month picker standard
         * - String format (YYYY-MM) - ISO-like format
         * - Any valid date string parseable by Date constructor
         * - Timestamp (number) - milliseconds or seconds since Unix epoch
         * - Date object
         * - LocalMonth array [year, month]
         *
         * Always returns YYYY-MM format string when getting the value.
         *
         * @attr {MonthValue} value - Any value that can be parsed to a month
         * @example
         * // String formats
         * <sds-month-picker value="2024-03"></sds-month-picker>
         * <sds-month-picker value="2024/03"></sds-month-picker>
         * <sds-month-picker value="March 2024"></sds-month-picker>
         *
         * // Timestamp
         * <sds-month-picker value="1710460800000"></sds-month-picker>
         *
         * // Programmatic usage
         * monthPicker.value = new Date();
         * monthPicker.value = 1710460800000;
         * monthPicker.value = "March 2024";
         * monthPicker.value = [2024, 3];
         */
        get value() {
            if (!this._internalValue)
                return undefined;
            const [year, month] = this._internalValue;
            return `${year}-${String(month).padStart(2, '0')}`;
        }
        set value(val) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (val === undefined || val === null) {
                this._internalValue = undefined;
            }
            else {
                // Handle LocalMonth array directly
                if (Array.isArray(val) && val.length === 2) {
                    const [year, month] = val;
                    if (month >= 1 && month <= 12) {
                        this._internalValue = [year, month];
                        return;
                    }
                }
                // For everything else, use existing date parsing logic and extract year/month
                const parsedDate = parseAndValidateDate(val);
                if (parsedDate) {
                    const [year, month] = parsedDate;
                    this._internalValue = [year, month];
                }
                else {
                    this._internalValue = undefined;
                }
            }
        }
        /**
         * Internal getter for backward compatibility - returns the LocalMonth array format
         */
        get valueAsLocalMonth() {
            return this._internalValue;
        }
        /**
         * Gets/sets the selected month as a Date object (HTML5 input[type="month"] compatible).
         * The day is set to the 1st of the month.
         * @example
         * monthPicker.valueAsDate = new Date('2024-03-01');
         * console.log(monthPicker.valueAsDate); // Date object for March 1, 2024
         */
        get valueAsDate() {
            if (!this._internalValue)
                return null;
            const [year, month] = this._internalValue;
            // Create date for the 1st of the selected month
            const date = new Date();
            date.setFullYear(year, month - 1, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        set valueAsDate(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (value === null) {
                this._internalValue = undefined;
            }
            else {
                const year = value.getFullYear();
                const month = value.getMonth() + 1;
                this._internalValue = [year, month];
            }
        }
        /**
         * Gets/sets the selected month as milliseconds since Unix epoch (HTML5 input[type="month"] compatible).
         * The timestamp represents the 1st of the selected month.
         * @example
         * monthPicker.valueAsNumber = Date.parse('2024-03-01');
         * console.log(monthPicker.valueAsNumber); // 1709251200000
         */
        get valueAsNumber() {
            const date = this.valueAsDate;
            return date ? date.getTime() : NaN;
        }
        set valueAsNumber(value) {
            // Prevent value changes when disabled
            if (this.disabled) {
                return;
            }
            if (isNaN(value)) {
                this.valueAsDate = null;
            }
            else {
                this.valueAsDate = new Date(value);
            }
        }
        /** currentMonth is in {year}/{month} format */
        get currentMonth() { return __classPrivateFieldGet(this, _SdsMonthPicker_currentMonth_accessor_storage, "f"); }
        set currentMonth(value) { __classPrivateFieldSet(this, _SdsMonthPicker_currentMonth_accessor_storage, value, "f"); }
        /**
         * Hint for this month picker.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsMonthPicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsMonthPicker_hint_accessor_storage, value, "f"); }
        /**
         * True if this month picker is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsMonthPicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsMonthPicker_disabled_accessor_storage, value, "f"); }
        /**
         * True if this month picker is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsMonthPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsMonthPicker_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this month picker, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsMonthPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsMonthPicker_errorMessage_accessor_storage, value, "f"); }
        get _locale() { return __classPrivateFieldGet(this, _SdsMonthPicker__locale_accessor_storage, "f"); }
        set _locale(value) { __classPrivateFieldSet(this, _SdsMonthPicker__locale_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsMonthPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsMonthPicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsMonthPicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsMonthPicker__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.handleInputClick}"
                @keydown="${this.handleKeyDown}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu>
                <sds-inner-month-picker
                    id="sds-inner-month-picker"
                    locale="${this._locale}"
                    currentMonth="${this.currentMonth}"
                    @sds.inner-month-picker.changed="${this.handleMonthPicked}"
                    @sds.inner-month-picker.year-changed="${this.handleYearChanged}"
                >
                </sds-inner-month-picker>
            </sds-context-menu>
        `;
        }
        willUpdate(_changedProperties) {
            // Keep value and selectedMonth properties in sync for backward compatibility
            if (_changedProperties.has('_internalValue') && !_changedProperties.has('selectedMonth')) {
                this.selectedMonth = this._internalValue;
            }
            else if (_changedProperties.has('selectedMonth') &&
                !_changedProperties.has('_internalValue')) {
                this._internalValue = this.selectedMonth;
            }
            if (_changedProperties.has('_internalValue') || _changedProperties.has('selectedMonth')) {
                this.setMappers();
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('_internalValue') || _changedProperties.has('selectedMonth')) {
                const currentMonth = this._internalValue || this.selectedMonth;
                if (currentMonth) {
                    this.updateInput(currentMonth);
                }
                else {
                    this.updateInput();
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        async firstUpdated() {
            appendStylesToTheStyleRoot(this, 'sds-month-picker', this.stylesGlobal.cssText);
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsInnerMonthPicker = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#sds-inner-month-picker');
            if (sdsInnerMonthPicker) {
                this._sdsInnerMonthPicker = sdsInnerMonthPicker;
            }
        }
        updatePageIndex() {
            var _a, _b;
            const currentMonth = this._internalValue || this.selectedMonth;
            if (currentMonth) {
                (_a = this._sdsInnerMonthPicker) === null || _a === void 0 ? void 0 : _a.updatePageIndex(currentMonth[0]);
            }
            else if (this.currentMonth) {
                (_b = this._sdsInnerMonthPicker) === null || _b === void 0 ? void 0 : _b.updatePageIndex(monthKeyToDate(this.currentMonth)[0]);
            }
        }
        resetPage() {
            var _a;
            (_a = this._sdsInnerMonthPicker) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectMonth');
            this.updatePageIndex();
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        dispatchChange() {
            const currentMonth = this._internalValue;
            const change = new CustomEvent(SdsMonthPicker.MONTH_PICKER_CHANGE_EVENT, {
                detail: {
                    selectedMonth: currentMonth ? monthDateToKey(...currentMonth) : undefined,
                },
            });
            this.dispatchEvent(change);
            const nativeChange = new CustomEvent(SdsMonthPicker.NATIVE_CHANGE_EVENT, {
                detail: {
                    selectedMonth: currentMonth ? monthDateToKey(...currentMonth) : undefined,
                },
            });
            this.dispatchEvent(nativeChange);
            // Dispatch specific cleared event when value is undefined
            if (!currentMonth) {
                const clearedEvent = new CustomEvent(SdsMonthPicker.MONTH_PICKER_CLEARED_EVENT, {
                    detail: {
                        selectedMonth: undefined,
                    },
                });
                this.dispatchEvent(clearedEvent);
            }
        }
        updateSelectedMonth(month) {
            this._internalValue = month;
            this.updatePageIndex();
            this.dispatchChange();
            this.setMappers();
        }
        setMappers() {
            var _a, _b;
            const currentMonth = this._internalValue || this.selectedMonth;
            const [year, month] = currentMonth ? currentMonth : [];
            (_a = this._sdsInnerMonthPicker) === null || _a === void 0 ? void 0 : _a.setMonthStateMapper(([keyYear, keyMonth]) => year === keyYear && month === keyMonth ? 'selected' : 'none');
            (_b = this._sdsInnerMonthPicker) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(keyYear => year === keyYear ? 'selected' : 'none');
        }
        updateInput(month) {
            this._inputDate.value = month ? displayMonthDate(month) : '';
        }
        /**
         * Focuses the month picker input field.
         * @example
         * monthPicker.focus();
         */
        focus() {
            this._inputDate.focus();
        }
        /**
         * Removes focus from the month picker and closes the menu if open.
         * @example
         * monthPicker.blur();
         */
        blur() {
            this._inputDate.blur();
            this.hideContextMenu();
        }
        /**
         * Programmatically clicks the month picker, which opens the dropdown.
         * This is equivalent to clicking on the month picker input.
         * @example
         * monthPicker.click();
         */
        click() {
            this.showContextMenu();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
    };
    _SdsMonthPicker_placeholder_accessor_storage = new WeakMap();
    _SdsMonthPicker_selectedMonth_accessor_storage = new WeakMap();
    _SdsMonthPicker__internalValue_accessor_storage = new WeakMap();
    _SdsMonthPicker_currentMonth_accessor_storage = new WeakMap();
    _SdsMonthPicker_hint_accessor_storage = new WeakMap();
    _SdsMonthPicker_disabled_accessor_storage = new WeakMap();
    _SdsMonthPicker_invalid_accessor_storage = new WeakMap();
    _SdsMonthPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsMonthPicker__locale_accessor_storage = new WeakMap();
    _SdsMonthPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsMonthPicker__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsMonthPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _selectedMonth_decorators = [property({
                attribute: 'selected-month',
                converter: monthKeyToDate,
            })];
        __internalValue_decorators = [property({
                converter: {
                    fromAttribute: (value) => {
                        if (!value)
                            return undefined;
                        const parsedDate = parseAndValidateDate(value);
                        if (parsedDate) {
                            const [year, month] = parsedDate;
                            return [year, month];
                        }
                        return undefined;
                    },
                    toAttribute: (value) => {
                        if (!value)
                            return '';
                        return monthDateToKey(...value);
                    },
                },
                attribute: 'value',
            })];
        _currentMonth_decorators = [property({ attribute: 'current-month' })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __locale_decorators = [state()];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _selectedMonth_decorators, { kind: "accessor", name: "selectedMonth", static: false, private: false, access: { has: obj => "selectedMonth" in obj, get: obj => obj.selectedMonth, set: (obj, value) => { obj.selectedMonth = value; } }, metadata: _metadata }, _selectedMonth_initializers, _selectedMonth_extraInitializers);
        __esDecorate(_classThis, null, __internalValue_decorators, { kind: "accessor", name: "_internalValue", static: false, private: false, access: { has: obj => "_internalValue" in obj, get: obj => obj._internalValue, set: (obj, value) => { obj._internalValue = value; } }, metadata: _metadata }, __internalValue_initializers, __internalValue_extraInitializers);
        __esDecorate(_classThis, null, _currentMonth_decorators, { kind: "accessor", name: "currentMonth", static: false, private: false, access: { has: obj => "currentMonth" in obj, get: obj => obj.currentMonth, set: (obj, value) => { obj.currentMonth = value; } }, metadata: _metadata }, _currentMonth_initializers, _currentMonth_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __locale_decorators, { kind: "accessor", name: "_locale", static: false, private: false, access: { has: obj => "_locale" in obj, get: obj => obj._locale, set: (obj, value) => { obj._locale = value; } }, metadata: _metadata }, __locale_initializers, __locale_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsMonthPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.MONTH_PICKER_CHANGE_EVENT = 'sds.month-picker.changed';
    _classThis.MONTH_PICKER_CLEARED_EVENT = 'sds.month-picker.cleared';
    _classThis.NATIVE_CHANGE_EVENT = 'change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsMonthPicker = _classThis;
})();
export { SdsMonthPicker };
